module.exports = __webpack_public_path__ + "static/media/Completed.e02a705d.svg";